<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.TECHNICAL_SUPPORT</span>
</div>

<tb-header specificTitle="COMMONS.TECHNICAL_SUPPORT"></tb-header>
<div class="contentGlobal">
    <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div>
            <ms-bugs-report-release-notes-card></ms-bugs-report-release-notes-card>
        </div>
        <div *ngIf="canSeeIncidentsCatalog">
            <ms-incidents-catalog-card></ms-incidents-catalog-card>
        </div>
        <div>
            <ms-help-center-products-card></ms-help-center-products-card>
        </div>
        <div *ngIf="false">
            <ms-suggestions-card></ms-suggestions-card>
        </div>
        <div *ngIf="canSeePassKey">
            <ms-passkey-card></ms-passkey-card>
        </div>
        <div *ngIf="canSeeTicketingHDA">
            <ms-ticketing-hda-card></ms-ticketing-hda-card>
        </div>
    </div>
</div>
